import debounce from 'lodash/debounce';
import { useState } from 'react';

interface useAutoCompleteProps<T> {
  options: T[];
  filter: (filterBy: string) => (item: T) => boolean;
}

export function useAutoComplete<T>({ options, filter }: useAutoCompleteProps<T>) {
  const [filteredOptions, setFilteredOptions] = useState(options);

  const loadOptions = debounce((filterBy: string) => {
    setFilteredOptions(options.filter(filter(filterBy)));
  }, 100);

  return { options: filteredOptions, loadOptions };
}
